export function getNonUmbracoUrl(url?: string) {
  if (!url) {
    return "/"
  }
  if (url?.includes("pages/home")) {
    return "/"
  }
  if (!url?.includes("pages")) {
    return url
  }

  // Drop everything up to and including the last "/pages" segment. Done with lastIndexOf
  // rather than /.*\/pages/ — the greedy prefix made that regex a polynomial-ReDoS target
  // (CodeQL js/polynomial-redos) on a function reachable from CMS-supplied URLs.
  const marker = "/pages"
  const lastIndex = url.lastIndexOf(marker)
  if (lastIndex === -1) {
    return url
  }

  return url.slice(lastIndex + marker.length)
}
